module.exports = __webpack_public_path__ + "img/training-card.81aa1cbb.svg";